module.exports = __webpack_public_path__ + "img/A2_9.81114d39.gif";